import React, { createContext, useEffect, useRef, useState } from 'react';
import Header from '../../Header/Header';
import Sidebar from '../../Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../../data/SiteConfig';
import {
  statementContainer,
  tabelContainer,
  dragLiner,
  showBorder,
  header,
  showBorderHover,
  topBtn,
  btnAnimate
} from './ManuallyAddBankStatement.module.css';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import TableBody from './TableBody';
import ResiizeObserver from '../../ResizeObserver/ResizeObserver';
import {
  getstatementTransactions,
  getBankStatementPrimaryTags
} from '../../../constants/bank-statement-api';
import { getAuthToken } from '../../../utils/cookie-utils';
import InfiniteScroll from '../../InfiniteScroll/InfiniteScroll';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { getDocSignedUrl } from '../../../constants/api';
import DocShowSection from './DocShowSection';
import BankStatementInsight from '../../BankStatementInsights/BankStatementInsight';
export const LeadData = createContext('');
const ManuallyAddBankStatement = props => {
  const [pdfloading, setPDFLoading] = useState(false);
  const [openingBalance, setOpeningBalance] = useState('Rs 0');
  const [transactionDetaiils, setTransactionDetails] = useState([]);
  const [trnsManualEntry, setTrnsManualEntry] = useState([]);
  const [totalData, setTotalData] = useState();
  const [currentPage, setCurrPage] = useState('rawData');
  const [inputFocus, setInputFocus] = useState('openingBalance');
  const [isAddBtnEnabeld, setAddBtnEnabeld] = useState(true);
  const [ftDrag, setFTdrag] = useState(false);
  const [resizeDiv, setResizeDiv] = useState(false);
  const [fileDivWidth, setFileDivWidth] = useState();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [pageLoading, setPageLoading] = useState(true);
  const [showDocSection, setShowDocSection] = useState(true);
  const [pauseTheInfiniteScroll, setPauseTheInfiniteScroll] = useState(false);
  const [signedUrl, setSignedUrl] = useState('');
  const [primaryTags, setPrimaryTags] = useState([
    {
      value: '',
      label: 'Select Tag'
    }
  ]);

  const transactionPage = useRef();
  const { leadId, applicantId, docId } = props;

  const fileRef = useRef();
  const transactionRef = useRef();
  const pageRef = useRef();

  const [transactionWidth, setTransactionWidth] = useState();

  const getPrimaryTags = () => {
    getBankStatementPrimaryTags().then(res => {
      if (typeof res !== 'object') return;
      let filtered_values = res?.filter(each => each !== 'Other')?.sort();
      let format_values = filtered_values?.map(each => {
        return { label: each, value: each };
      });
      let tag_list = [
        {
          value: '',
          label: 'Select Tag'
        },
        ...format_values
      ];
      if (res?.includes('Other'))
        setPrimaryTags([...tag_list, { value: 'Other', label: 'Other' }]);
      else setPrimaryTags(tag_list);
    });
  };
  useEffect(() => {
    getPrimaryTags();
  }, []);
  const addNewRow = useRef('');
  const tableHeadCol = `font-barlow text-black-500 text-left px-2 sticky py-5 bg-white ${header}`;
  const handleClick = () => {
    setInputFocus(`m${trnsManualEntry?.length}`);
    setPauseTheInfiniteScroll(true);
    setTimeout(() => {
      setTrnsManualEntry([...trnsManualEntry, {}]);
    }, 100);
  };
  const getNumber = val => {
    return val ? parseFloat(`${val}`?.replace(/,/g, '') || 0) : 0;
  };

  const handleResizeDiv = e => {
    if (!fileRef?.current) return;
    if (!resizeDiv) return;
    setFileDivWidth(fileRef?.current?.clientWidth + e?.movementX);
    setTransactionWidth(
      transactionRef?.current?.clientWidth -
        fileRef?.current?.clientWidth -
        e?.movementX
    );
  };
  const handleResizeTransactionDiv = () => {
    if (!fileRef?.current) return setTransactionWidth('100%');

    if (transactionPage?.current?.clientWidth > 768)
      setTransactionWidth('58.33%');
    else {
      setTransactionWidth('100%');
    }
  };
  const handleDBClick = () => {
    setResizeDiv(true);
  };

  const getBnakStatements = data => {
    setPageLoading(true);
    getstatementTransactions(data)
      .then(res => {
        if (res?.transactions?.length == 0 && data?.page_number == 1) {
          setTrnsManualEntry([{}]);
        }
        setTransactionDetails([...transactionDetaiils, ...res?.transactions]);
        setTotalData(res?.total_data || 0);
        setPageLoading(false);
      })
      .catch(error => {
        setTransactionDetails([]);
        setPageLoading(false);
        setTrnsManualEntry([{}]);
      });
  };

  const getImgUrl = () => {
    setPDFLoading(true);
    getDocSignedUrl(docId)
      .then(res => {
        setSignedUrl(res);
        setPDFLoading(false);
      })
      .catch(error => {
        setSignedUrl('');
        setPDFLoading(false);
      });
  };
  useEffect(() => {
    getBnakStatements({
      token: getAuthToken(),
      page_number: page,
      page_size: size,
      lead_id: leadId,
      applicant_id: applicantId,
      doc_id: docId
    });
    getImgUrl();
  }, []);

  const handleInfiniteScroll = () => {
    if (pauseTheInfiniteScroll) return;
    getBnakStatements({
      token: getAuthToken(),
      page_number: page + 1,
      page_size: size,
      lead_id: leadId,
      applicant_id: applicantId,
      doc_id: docId
    });
    setPage(page + 1);
  };
  return (
    <div className="w-full bg-green-athensGray" ref={transactionPage}>
      <Helmet title={`Bank Statement  | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-hidden font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          <div className="widhtMd max-screen flex-1  w-full ">
            <div className="flex">
              <Header />
            </div>
            <div
              className={`w-auto table ${btnAnimate} ${
                currentPage == 'rawData' ? ' mx-auto ' : 'mr-auto px-2'
              }`}
            >
              <div className={`flex items-center ${!signedUrl && 'hidden'}`}>
                <button
                  type="button"
                  onClick={() => {
                    setCurrPage('rawData');
                  }}
                  className={`font-roboto ${
                    currentPage == 'rawData'
                      ? 'bg-yellow-fuelYellow text-black-1002 border'
                      : 'text-black-500 border-b border-t border-l'
                  }   text-sm px-3 py-1 rounded  border-grey-1001 ${topBtn}`}
                >
                  Raw Data
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setCurrPage('insight');
                  }}
                  className={`font-roboto  ${
                    currentPage == 'insight'
                      ? 'bg-yellow-fuelYellow text-black-1002 border'
                      : 'text-black-500 border-b border-t border-r'
                  } text-sm px-3 -ml-0.5 py-1 rounded  border-grey-1001 ${topBtn}`}
                >
                  Insight
                </button>
              </div>
            </div>
            <LeadData.Provider value={{ leadId, applicantId, docId }}>
              {currentPage == 'insight' && (
                <div className="w-full pt-5 ml-1">
                  <BankStatementInsight url={signedUrl} />
                </div>
              )}
            </LeadData.Provider>
            <div className={`${currentPage !== 'rawData' && 'hidden'}`}>
              <ResiizeObserver
                targetNodeRef={pageRef}
                handleCallBack={handleResizeTransactionDiv}
                debounceInterval="1000"
              >
                <div className="w-full px-3">
                  <div
                    className={`w-full  py-2  rounded px-3 ${statementContainer}`}
                  >
                    <div
                      className="w-full block md:flex overflow-auto mt-5"
                      onMouseUp={() => {
                        setResizeDiv(false);
                      }}
                      onMouseMove={handleResizeDiv}
                      ref={transactionRef}
                    >
                      {showDocSection && (
                        <DocShowSection
                          fileRef={fileRef}
                          fileDivWidth={fileDivWidth}
                          pdfloading={pdfloading}
                          signedUrl={signedUrl}
                          setShowDocSection={setShowDocSection}
                          setTransactionWidth={setTransactionWidth}
                        />
                      )}
                      <div
                        className={`cursor-resize hidden md:block ${dragLiner}`}
                        onMouseDown={handleDBClick}
                        style={{ width: '10px' }}
                      />
                      <div
                        className={`bg-white px-4 py-7 rounded   rounded w-full md:w-7/12 overflow-auto ${resizeDiv &&
                          showBorder} ${showBorderHover} ${tabelContainer}`}
                        style={{ width: transactionWidth }}
                      >
                        <div className="w-full block md:flex  bg-white py-3  overflow-auto ">
                          <h3 className="font-roboto w-full font-bold text-lg text-left">
                            List of Financial Transactions
                          </h3>
                        </div>
                        {currentPage == 'rawData' && (
                          <InfiniteScroll
                            bottomLocation={40}
                            debounceTime={100}
                            handleScrollsuccess={handleInfiniteScroll}
                            disable={false}
                            pageInfo={{
                              totalPages: Math.ceil(totalData / size) || 0,
                              number: page - 1
                            }}
                            includeFilterLoder={pageLoading}
                          >
                            <div className="w-full  overflow-auto pb-8 ">
                              <table className="w-full">
                                <thead>
                                  <tr>
                                    <th className={`${tableHeadCol}`}></th>
                                    <th className={`${tableHeadCol}`}>
                                      Transaction Date
                                    </th>
                                    <th className={`${tableHeadCol} `}>
                                      Particular
                                    </th>
                                    <th className={`${tableHeadCol} `}>Tag</th>
                                    <th className={`${tableHeadCol} `}>
                                      Deposit
                                    </th>
                                    <th className={`${tableHeadCol} `}>
                                      Withdrawal
                                    </th>
                                    <th className={`${tableHeadCol}`}>
                                      Closing Balance
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {transactionDetaiils.map((each, index) => {
                                    return (
                                      <TableBody
                                        primaryTags={primaryTags}
                                        each={each}
                                        index={index}
                                        keyV={index}
                                        transactionDetaiils={
                                          transactionDetaiils
                                        }
                                        setTransactionDetails={
                                          setTransactionDetails
                                        }
                                        getNumber={getNumber}
                                        inputFocus={inputFocus}
                                        setInputFocus={setInputFocus}
                                        openingBalance={openingBalance}
                                        name="oldTransaction"
                                        leadId={leadId}
                                        applicantId={applicantId}
                                        docId={docId}
                                      />
                                    );
                                  })}
                                  <tr>
                                    <td colSpan="7">
                                      {transactionDetaiils?.length ==
                                        totalData &&
                                        transactionDetaiils?.length != 0 && (
                                          <p className="text-center font-roboto text-black-500 text-sm">
                                            No More Data!
                                          </p>
                                        )}
                                    </td>
                                  </tr>
                                  {trnsManualEntry?.length != 0 &&
                                    transactionDetaiils?.length != totalData &&
                                    transactionDetaiils?.length != 0 && (
                                      <tr className="py-2">
                                        <td colSpan="7">
                                          <div className="table mx-auto text-center">
                                            <MoreVertIcon />

                                            <p className="text-center font-roboto text-sm text-black-500">
                                              <span className="font-bold mr-0.5">
                                                {totalData -
                                                  transactionDetaiils?.length}
                                              </span>
                                              more deatils...
                                            </p>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  {trnsManualEntry.map((each, index) => (
                                    <TableBody
                                      primaryTags={primaryTags}
                                      each={each}
                                      index={index}
                                      keyV={`m${index}`}
                                      transactionDetaiils={trnsManualEntry}
                                      setTransactionDetails={setTrnsManualEntry}
                                      getNumber={getNumber}
                                      inputFocus={inputFocus}
                                      setInputFocus={setInputFocus}
                                      openingBalance={openingBalance}
                                      leadId={leadId}
                                      applicantId={applicantId}
                                      docId={docId}
                                      name="newTransaction"
                                    />
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </InfiniteScroll>
                        )}
                        <div className="table float-right mt-7">
                          <AddCircleIcon
                            className={`text-blue-500 cursor-pointer w-12 h-12 ${!isAddBtnEnabeld &&
                              'opacity-50 cursor-not-allowed'}`}
                            ref={addNewRow}
                            onClick={handleClick}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ResiizeObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ManuallyAddBankStatement);
